import { useQuery } from '@tanstack/react-query';
import { api, GrTimePlayedLeaderboardResult } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';

interface UseTimePlayedLeaderboardReturn {
  data: GrTimePlayedLeaderboardResult | null;
  loading: boolean;
  error: string | null;
  refresh: () => void;
}

/** Time-played leaderboard + community totals for a single game. */
export function useTimePlayedLeaderboard(
  gameConfigId: string | null,
): UseTimePlayedLeaderboardReturn {
  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: queryKeys.gameRewards.timeLeaderboard(gameConfigId!),
    queryFn: () => api.getGameRewardsTimeLeaderboard(gameConfigId!),
    enabled: !!gameConfigId,
  });

  return {
    data: data ?? null,
    loading: isLoading,
    error:
      error instanceof Error ? error.message : isError ? 'Failed to load time leaderboard' : null,
    refresh: () => {
      refetch();
    },
  };
}
